<template>
  <div class="flex pt16 pl12 pr16 product-list">
    <div
      class="img-content"
      @click="pageDetail(item.itemId, item.isDrug)"
      v-track-event.click="{ trackId: 'zyyd-click-CartGoods', custom: { itemId: item.itemId } }"
    >
      <van-image width="72" height="72" :src="item.mainImg" :ref="'fly-img' + item.itemId"></van-image>
      <span
        class="rx-shade"
        v-if="item.isDrug === 1 && item.isRx === RxTypeNum.CHUFANGYA0 && rxShadeConfig['shop-compliance-open']"
        :style="rxShadeStyle"
      >
        {{ rxShadeConfig['shop-compliance-content']['tips'] }}
      </span>
      <fly-product :dropImage="item.mainImg" :ref="'fly-product' + item.itemId" class="drop-image" />
      <span v-if="item.status === 1" class="no-stockNum">下架</span>
      <span v-else-if="item.stockNum === 0" class="no-stockNum">售罄</span>
      <div class="mask" v-if="(!item.stockNum || item.status) && !flyButton"></div>
    </div>
    <div class="right" :class="{ 'show-bottom-border': !showBorder }">
      <div
        class="name ellipsis"
        @click="pageDetail(item.itemId, item.isDrug)"
        v-track-event.click="{ trackId: 'zyyd-click-CartGoods', custom: { itemId: item.itemId } }"
      >
        {{ item.name || item.itemName }}
      </div>
      <div
        class="company ellipsis"
        @click="pageDetail(item.itemId, item.isDrug)"
        v-track-event.click="{ trackId: 'zyyd-click-CartGoods', custom: { itemId: item.itemId } }"
      >
        {{ item.manufacturer }}
      </div>
      <div
        class="size"
        @click="pageDetail(item.itemId, item.isDrug)"
        v-track-event.click="{ trackId: 'zyyd-click-CartGoods', custom: { itemId: item.itemId } }"
      >
        {{ item.specifications }}
      </div>
      <div class="flex space-between mt8">
        <div
          class="price"
          v-show="(item.stockNum && !item.status) || flyButton"
          @click="pageDetail(item.itemId, item.isDrug)"
          v-track-event.click="{ trackId: 'zyyd-click-CartGoods', custom: { itemId: item.itemId } }"
        >
          {{ item.realPrice | parsePrice }}
        </div>
        <div class="action">
          <van-button
            type="primary"
            size="mini"
            class="sub_button"
            v-if="flyButton"
            v-reClick="add"
            v-track-event="{ trackId: 'zyyd-click-Add2Cart', custom: { itemId: item.itemId } }"
          >
            加入需求清单
          </van-button>
          <van-stepper
            v-else-if="item.stockNum"
            :ref="'stepper' + item.itemId"
            :value="item.amount || ''"
            theme="round"
            integer
            allow-empty
            @plus="plus"
            @minus="minus"
            @blur="handleBlur"
            @overlimit="overlimit(item)"
            @change="handChange"
            async-change
            :show-minus="item.amount > 0"
            :show-plus="item.stockNum !== 0"
            :min="0"
            :max="item.stockNum < 999 ? item.stockNum : 999"
            button-size="22"
            :disable-input="item.amount === 0"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FlyProduct from './flyProduct';
import { mapState } from 'vuex';
import { RxTypeNum } from '@/constant';

export default {
  props: ['item', 'flyButton', 'showBorder'],
  components: {
    FlyProduct
  },
  data() {
    return {
      digit: '',
      RxTypeNum,
      isTip: false // 是否提示用户
    };
  },
  computed: {
    ...mapState(['rxShadeConfig']),
    rxShadeStyle() {
      const content = this.rxShadeConfig['shop-compliance-content'];
      return {
        color: `#${content.textColor}`,
        background: `#${content.bgColor}`,
        opacity: content.alpha,
        fontSize: `${content.textSize}px`
      };
    },
  },
  methods: {
    add() {
      const { itemId, isDrug } = this.item;
      this.$fetch.addOneTrolley({ itemId, isDrug }).then(({ stockNum, canAdd, message = '' }) => {
        if (!canAdd) {
          this.item.stockNum = stockNum;
          this.$toast(message);
          return;
        }
        // eslint-disable-next-line
        Telescope.trackEvent({ trackId: 'yd_category_productlist_add' });
        this.$refs['fly-product' + itemId].addToCart(this.$refs['fly-img' + itemId]);
        window.localStorage.setItem('recentAddType', isDrug);
        this.$emit('update:requestCount', 1);
      });
    },
    pageDetail(itemId, isDrug) {
      this.$router.push({ path: `/specification?itemId=${itemId}&isDrug=${isDrug}` });
    },

    // 删除购物车
    deleteTrolley() {
      const { itemId, isDrug } = this.item;
      this.$dialog
        .confirm({
          title: '确认删除药品？',
          confirmButtonText: '再想想',
          cancelButtonText: '删除'
        })
        .then(() => {
          this.$refs['stepper' + itemId].currentValue = this.item.amount;
        })
        .catch(() => {
          this.$fetch.deleteTrolley({ itemId, isDrug }).then(() => {
            this.$emit('handleDelete', itemId);
          });
        });
    },
    addTrolley(amount, bol) {
      // if (amount === this.item.amount) return;
      const { itemId, isDrug } = this.item;
      this.$fetch.addTrolley({ itemId, amount, isDrug }).then(({ stockNum, canAdd, message = '', status }) => {
        if (bol) {
          this.$toast('输入商品数量至少1件');
        }
        if (!canAdd) {
          this.item.stockNum = stockNum;
          if (status) this.item.status = status;

          this.$toast(message);
          return;
        }
        if (this.isTip) {
          this.overlimit();
        }
        this.item.amount = amount;
      });
    },
    minus() {
      const amount = Number(this.$refs['stepper' + this.item.itemId].currentValue) - 1;
      if (amount < 1) {
        this.deleteTrolley();
        return;
      }
      this.addTrolley(amount);
    },
    plus() {
      const amount = Number(this.$refs['stepper' + this.item.itemId].currentValue) + 1;
      this.addTrolley(amount);
    },
    handleBlur() {
      const amount = Number(this.$refs['stepper' + this.item.itemId].currentValue);
      if (amount === 0) {
        this.$refs['stepper' + this.item.itemId].currentValue = 1;
        return this.addTrolley(1, true);
      }
      this.addTrolley(amount);
    },
    // 点击不可用按钮触发
    overlimit() {
      if (this.item.stockNum < 999) {
        this.$toast(`您最多可购买${this.item.stockNum}件`);
      } else {
        this.$toast('您最多可购买999件');
      }
    },
    handChange(v) {
      if (v === 999 || v === this.item.stock) return;
      this.isTip = !!(Number(v) > this.item.stock);
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list {
  width: 100%;
  position: relative;

  .drop-image {
    position: absolute;
    top: 0;
    left: 0;
  }
}
.show-bottom-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.img-content {
  position: relative;
  .mask {
    position: absolute;
    display: inline-block;
    width: 72px;
    height: 72px;
    left: 0;
    top: 0;
    background: rgba(51, 51, 51, 0.8);
    z-index: 1;
    border-radius: 4px;
    opacity: 0.5;
  }
  .no-stockNum {
    position: absolute;
    display: inline-block;
    width: 50px;
    height: 50px;
    z-index: 2;
    background: #333333;
    box-shadow: 0px 1px 4px 0px rgba(51, 51, 51, 0.5);
    opacity: 0.8;
    top: 11px;
    left: 11px;
    border-radius: 50px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 50px;
  }
  .rx-shade {
    position: absolute;
    top: 0;
    left: 0;
    width: 72px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.right {
  margin-left: 8px;
  width: calc(100% - 78px);
  padding-bottom: 12px;

  .name {
    font-size: 16px;
    line-height: 24px;
    color: #262626;
    font-weight: 500;
  }
  .company,
  .size {
    max-width: 70%;
    line-height: 16px;
    margin-top: 4px;
    font-size: 12px;
    color: #8c8c8c;
  }
  .size {
    max-width: 50%;
  }
  .price {
    max-width: 50%;
    font-size: 14px;
    font-weight: 500;
    color: #f94242;
    line-height: 24px;
  }

  .sub_button {
    width: 88px;
    height: 24px;
    padding: 0;
    font-size: 12px !important;
    border-radius: 4px;
  }
  ::v-deep.van-stepper__minus {
    color: #262626;
    background-color: #fff;
    border: 1px solid #118dff;
  }
  ::v-deep.van-stepper__plus {
    color: #fff;
    background-color: #1e8dff;
  }
  ::v-deep.van-stepper__plus,
  ::v-deep.van-stepper__minus {
    border-radius: 6px;
  }
}
</style>
